import React from "react";

import "./TournamentCardSkeleton.scss";
import Skeleton from "../../Skeleton/Skeleton";

export default function TournamentCardSkeleton() {
  return (
    <div className="tournament-card-skeleton">
      <Skeleton className="tournament-card-poster-skeleton" borderRadius={16} />
      <div className="tournament-card-skeleton-content">
        <div className="tournament-card-skeleton-top">
          <Skeleton height={24} width={92} borderRadius={30} />
          <Skeleton height={24} width={67} borderRadius={30} />
        </div>
        <div className="tournament-card-skeleton-bottom">
          <Skeleton height={32} width={112} borderRadius={8} />
          <Skeleton height={24} width={164} borderRadius={8} />
          <Skeleton height={24} width={82} borderRadius={30} />
        </div>
      </div>
    </div>
  );
}
